export default __webpack_public_path__ + "static/circle-5fb2d1e60df553800e1d1c2e0dec6a84.png";